import * as tslib_1 from "tslib";
import { Component } from 'vue-property-decorator';
import DataTable from '@/components/DataTable/DataTable.vue';
import JSPage from '@/classes/JSPage';
import CustomerService from '@/services/CustomerService';
let CustomersPage = class CustomersPage extends JSPage {
    constructor() {
        super(...arguments);
        this.customerService = new CustomerService();
        this.headers = [];
        this.filters = [];
    }
    created() {
        super.created();
    }
    main() {
        this.setHeaders();
        this.setFilters();
    }
    setHeaders() {
        this.headers = [
            { text: 'Nombre', value: 'name', align: 'start' },
            { text: '', value: 'actions', align: 'end', sortable: false }
        ];
    }
    setFilters() {
        this.filters = [
            { text: 'Nombre', value: 'name', content: '', toggle: true, type: 'text' },
        ];
    }
};
CustomersPage = tslib_1.__decorate([
    Component({
        components: {
            DataTable
        }
    })
], CustomersPage);
export default CustomersPage;
